import axios from 'axios'
import { IMetadatos } from '@/services/artefactos/metadatos';
import moment from 'moment';
import AccessToken from '../accessToken.service';
moment().format();
moment.locale('es-mx');

export default class Metadatos {
    private accessToken = new AccessToken();
    
    public async getMetadatos(id_tipo_conjunto?: string, id_objeto?: string): Promise<IMetadatos[] | undefined> {
        try {
            const api = process.env.VUE_APP_ARTEFACTOS_API + 'ObtenerDifusionMetadatos';
            const config = {                    
                params: {
                    id_tipo_conjunto: id_tipo_conjunto,                    
                    id: id_objeto
                },
                headers: {
                    Authorization: `Bearer ${await this.accessToken.getAccessToken()}`,
                    Content: 'application/json; charset=utf-8',
                    responseType: "json"
                }
            };

            const result = await  axios.get(api, config);            
            if (result.data == null)
            {
                throw new Error('Valor nulo'); 
            }

            //console.log('result.data:',result.data);
            return result.data; 

        } catch (error) {
            throw new Error('API (Obtener Metadatos). ' + error) 
        }
    }

    public async obtenerModuloSistemaClasificacion( id_elemento?: number, id_modulo?: number): Promise<[] | undefined> {
        try {
            const api = process.env.VUE_APP_ARTEFACTOS_API + 'ObtenerModuloSistemaClasificacion';

            const config = {                    
                params: {
                    id_modulo: id_modulo,                    
                    id_elemento: id_elemento
                },
                headers: {
                    Authorization: `Bearer ${await this.accessToken.getAccessToken()}`,
                    Content: 'application/json; charset=utf-8',
                    responseType: "json"
                }
            };

            const result = await  axios.get(api, config);            
            if (result.data == null)
            {
                throw new Error('Valor nulo'); 
            }

            return result.data; 

        } catch (error) {
            throw new Error('API (ObtenerModuloSistemaClasificacion). ' + error) 
        }
    }    

}

